import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "@similarweb/ui-components";

const { carbon } = colorsPalettes;

export const Title = styled.div`
    padding: 20px 24px;
    ${setFontVariant("h5", carbon[500])};
`;

export const Body = styled(FlexColumn)`
    padding: 16px 24px 24px 24px;
    gap: 16px;
`;

export const Message = styled.div`
    ${setFontVariant("body1", carbon[400])};
`;

export const CountryWrapper = styled.div`
    position: relative;
`;

export const Footer = styled(FlexRow)`
    justify-content: end;
`;
